import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageDtoKeyEnum } from '@zaoblako/shared/modules/storage/enums/storage-dto-key.enum';

import * as yup from 'yup';

/** Common files statistics response body - DTO signature */
export interface StatFindInterface {
  /** Number of files uploaded to storage */
  filesCount: number;
  /** Size of all files uploaded to storage */
  filesSize: number;
}

/** Common files statistics response body - DTO schema */
export const StatFindDto = SerdeDtoClass.create<StatFindInterface>(StorageDtoKeyEnum.STAT_FIND_DTO, {
  filesCount: {
    sortable: true,
    label: 'Количество загруженных файлов',
    serializer: yup.number(),
  },
  filesSize: {
    sortable: true,
    label: 'Суммарный объем загруженных файлов',
    serializer: yup.number(),
  },
});
